import Sections from "../Sections/List";

export const tabDetails = (selectedPlanDetail: any, planType: string) => {
  return [
    {
      label: "Action Plan",
      content: Hoc(Sections, selectedPlanDetail, planType)
    }
  ];
};

function Hoc(WrappedComponent: any, data: any, planType: string) {
  return function (props: any) {
    return <WrappedComponent {...props} selectedPlanDetail={data} planType={planType} />;
  };
}
